import Vue from 'vue'

let $parseDateFromString = (stringDate = null, delimiter = '-') => {
    if (stringDate === null) return null;
    let splitedString = stringDate.split(delimiter);
    let date = new Date();
    if(splitedString.length > 1){
        let month = +(splitedString[1]);
        let year = +(splitedString[0]);
        let day = splitedString[2] ? +(splitedString[2]) : 1;
        date.setFullYear(year, month-1, day);
        return date;
    }
    return date;
};

Vue.prototype.$parseDateFromString = $parseDateFromString;

export default $parseDateFromString;
